import CloseIcon from '../../../assets/closeIcon.svg?react';
import { IconButton } from '../atoms/IconButton';

interface ArrowIconButtonProps {
	onClick: () => void;
	className?: string;
	iconClassName?: string;
}

const iconButtonClasses = 'flex items-center justify-center';

export const CloseIconButton = ({
	onClick,
	className,
	iconClassName,
}: ArrowIconButtonProps) => {
	return (
		<IconButton
			className={`${className} ${iconButtonClasses}`}
			onClick={onClick}
			icon={<CloseIcon className={iconClassName} />}
		/>
	);
};
